var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{staticClass:"tw-mt-2 sm:tw-mt-4",attrs:{"timeout":5000,"value":_vm.alert.visible,"top":"","color":_vm.alert.color},on:{"input":_vm.onInput}},[_c('span',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.purifyAndAllowHtmlTags(_vm.alert.text)),expression:"purifyAndAllowHtmlTags(alert.text)"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }